import React, { useEffect } from "react";
import PropTypes from "prop-types";


import { useDispatch, useSelector } from "react-redux";
import { fetchContacts } from "store/contactSlice";
import MessageTableDropdown from "components/Dropdowns/MessageTableDropdown";

export default function MessageTable({ color }) {
 const dispatch = useDispatch();
  const { data: contacts, loading, error } = useSelector((state) => state.contacts);

  useEffect(() => {
    dispatch(fetchContacts());
  }, [dispatch]);

  return (
    <>
      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
        }
      >
        <div className="rounded-t mb-0 px-4 py-3 border-0">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full px-4 max-w-full flex-grow flex-1">
              <h3
                className={
                  "font-semibold text-lg " +
                  (color === "light" ? "text-blueGray-700" : "text-white")
                }
              >
                Message Tables
              </h3>
            </div>
          </div>
        </div>
        <div className="block w-full overflow-x-auto">
          {/* Projects table */}
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
              {["Name", "Email", "Message", ""].map((head, i) => (
                <th
                  key={i}
                  className={
                    "px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  {head}
                </th>
              ))}
            </tr>
            </thead>
            <tbody>
              {loading ? (
              <tr><td colSpan="4" className="text-center p-4">Loading...</td></tr>
            ) : error ? (
              <tr><td colSpan="4" className="text-center p-4 text-red-500">{error}</td></tr>
            ) : contacts.length === 0 ? (
              <tr><td colSpan="4" className="text-center p-4">No messages found.</td></tr>
            ) : (
              contacts.map((item) => (
              <tr key={item._id}>
                <th className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left flex items-center">
                  <span
                    className={
                      "ml-3 font-bold " +
                      +(color === "light" ? "text-blueGray-600" : "text-white")
                    }
                  >
                    {item.name}
                  </span>
                </th>
                <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  {item.email}
                </td>
                <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  {item.message}
                </td>
                <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-right">
                  <MessageTableDropdown messageId={item._id}/>
                </td>
              </tr>
              ))
            )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

MessageTable.defaultProps = {
  color: "light",
};

MessageTable.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
